export default "__VITE_ASSET__5ff14c21__"